// extracted by mini-css-extract-plugin
export var editButton = "_ps-0";